// extracted by mini-css-extract-plugin
export default {"description":"_64HmdetI3NAgrzgjFzU2eG","detail":"_4OyAQh0BGNSP0RHiQpBDg5","mapContainer":"_3pNOIAjKieJOCc8X4i93c5","map":"_8BmkT45xo4Xji481wYJ1d","address":"_6ih12Ms2ZT5UzhDH4x1TTR"};